export function isAtLeast18YearsOld(formatted: string): boolean {
  const validFormat = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/.test(formatted);
  if (!validFormat) return false;

  const [monthStr, dayStr, yearStr] = formatted.split('/');
  const month = parseInt(monthStr, 10) - 1;
  const day = parseInt(dayStr, 10);
  const year = parseInt(yearStr, 10);

  const birthDate = new Date(year, month, day);
  const today = new Date();
  const minDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());

  return birthDate <= minDate;
}
